export const getWichList = state => state.wichList.wichList;